import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { StoreProvider } from './context/StoreContext';
import { Layout } from './components/Layout';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Home } from './pages/Home';
import { ProductDetails } from './pages/ProductDetails';
import { Cart } from './pages/Cart';
import { Checkout } from './pages/Checkout';
import { MyOrders } from './pages/MyOrders';
import { OrderDetails } from './pages/OrderDetails';
import { AdminDashboard } from './pages/admin/AdminDashboard';
import { AdminLogin } from './pages/admin/AdminLogin';
import { CategoryPage } from './pages/CategoryPage';
import { versionChecker } from './utils/versionChecker';

function App() {
  const [showUpdateBanner, setShowUpdateBanner] = useState(false);

  useEffect(() => {
    // Start periodic version checking (every 5 minutes)
    // When a new version is detected, show update banner
    versionChecker.startPeriodicCheck((hasUpdate) => {
      if (hasUpdate) {
        console.log('New version available - showing update banner');
        setShowUpdateBanner(true);
      }
    });

    // Cleanup: stop checking when component unmounts
    return () => {
      versionChecker.stopPeriodicCheck();
    };
  }, []);

  const handleUpdate = () => {
    // Force reload to get the latest version
    versionChecker.forceReload();
  };

  return (
    <StoreProvider>
      {/* Update Banner - shows when new version is available */}
      {showUpdateBanner && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          backgroundColor: '#3b82f6',
          color: 'white',
          padding: '12px 16px',
          textAlign: 'center',
          zIndex: 9999,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '12px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
        }}>
          <span>🎉 A new version is available!</span>
          <button
            onClick={handleUpdate}
            style={{
              backgroundColor: 'white',
              color: '#3b82f6',
              border: 'none',
              padding: '6px 16px',
              borderRadius: '4px',
              fontWeight: '600',
              cursor: 'pointer',
            }}
          >
            Update Now
          </button>
          <button
            onClick={() => setShowUpdateBanner(false)}
            style={{
              backgroundColor: 'transparent',
              color: 'white',
              border: '1px solid white',
              padding: '6px 16px',
              borderRadius: '4px',
              cursor: 'pointer',
            }}
          >
            Later
          </button>
        </div>
      )}
      
      <Router>
        <Routes>
          {/* Admin routes without Layout wrapper */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route 
            path="/admin/*" 
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            } 
          />
          
          {/* Public routes with Layout wrapper */}
          <Route path="/*" element={
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/product/:slugOrId" element={<ProductDetails />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/orders" element={<MyOrders />} />
                <Route path="/orders/:orderId" element={<OrderDetails />} />
                <Route path="/category/:slugOrId" element={<CategoryPage />} />
                <Route path="/categories" element={<CategoryPage />} />
              </Routes>
            </Layout>
          } />
        </Routes>
      </Router>
    </StoreProvider>
  );
}

export default App;
